import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';

import { HealthpicksOperatorComponent } from './healthpicks-operator/healthpicks-operator.component';
import { HealthpicksOperatorRegisterSendComponent } from './healthpicks-operator-register-send/healthpicks-operator-register-send.component';
import { HealthpicksOperatorResetPasswordComponent } from './healthpicks-operator-reset-password/healthpicks-operator-reset-password.component';
import { HealthpicksOperatorUnblockComponent } from './healthpicks-operator-unblock/healthpicks-operator-unblock.component';
import { HealthpicksOperatorPasswordInputComponent } from './healthpicks-operator-password-input/healthpicks-operator-password-input.component';
import { HealthpicksOperatorChangePasswordSentComponent } from './healthpicks-operator-change-password-sent/healthpicks-operator-change-password-sent.component';
import { HealthpicksOperatorLoginComponent } from './healthpicks-operator-login/healthpicks-operator-login.component';
import { HealthpicksOperatorForgotPasswordComponent } from './healthpicks-operator-forgot-password/healthpicks-operator-forgot-password.component';
import { HealthpicksOperatorFieldErrorComponent } from './healthpicks-operator-field-error/healthpicks-operator-field-error.component';

@NgModule({
  declarations: [
    HealthpicksOperatorComponent,
    HealthpicksOperatorRegisterSendComponent,
    HealthpicksOperatorResetPasswordComponent,
    HealthpicksOperatorUnblockComponent,
    HealthpicksOperatorPasswordInputComponent,
    HealthpicksOperatorChangePasswordSentComponent,
    HealthpicksOperatorLoginComponent,
    HealthpicksOperatorForgotPasswordComponent,
    HealthpicksOperatorFieldErrorComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    HealthpicksOperatorComponent,
    HealthpicksOperatorRegisterSendComponent,
    HealthpicksOperatorResetPasswordComponent,
    HealthpicksOperatorUnblockComponent,
    HealthpicksOperatorChangePasswordSentComponent,
    HealthpicksOperatorLoginComponent,
    HealthpicksOperatorForgotPasswordComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HealthpicksOperatorModule {}
